import React, { forwardRef, type ForwardedRef } from 'react';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import type { ClickableButtonProps } from './ClickableButton.types';

export const ClickableButton = forwardRef<
  HTMLButtonElement,
  ClickableButtonProps
>(({ className, ...rest }, ref) => {
  const { as: asButtonProp, onClick, disabled, ...buttonRest } = rest;

  const defaultClasses = [
    'disabled:cursor-not-allowed',
    'disabled:opacity-40',
    'disabled:hover:opacity-40',
  ];

  return (
    <button
      ref={ref as ForwardedRef<HTMLButtonElement>}
      type="button"
      className={cn(defaultClasses, className)}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      {...buttonRest}
    />
  );
});
